import React,{useState,useEffect} from 'react';
import { T, alpha } from './poyais-ui/theme';
import { useLang } from './i18n';

const GOLD=T.accent,GOLD_L=T.accent,GOLD_DIM=alpha(T.accent,8),GOLD_BRD=alpha(T.accent,20);
const TX=T.text,MT=T.textMidAlt,BG=T.surface,S2=T.card,RED=T.red,GREEN=T.green;

const PACKAGES=[
  {id:'starter', name:'Küçük Paket', credits:100,  price:149,  desc:'Küçük kampanyalar için.',  popular:false},
  {id:'pro',     name:'Orta Paket',  credits:500,  price:599,  desc:'Büyüyen ajanslar için.',   popular:true},
  {id:'agency',  name:'Büyük Paket', credits:1500, price:1599, desc:'Tam kapasiteli çalışma.',  popular:false},
];

const TOOL_COSTS=[
  {tool:'AI Metin',  cost:1,  icon:'✍️'},
  {tool:'AI Görsel', cost:5,  icon:'🎨'},
  {tool:'AI Video',  cost:10, icon:'🎬'},
  {tool:'AI Ses',    cost:2,  icon:'🎙️'},
];

function useIsMobile(){ 
  const [m,setM]=React.useState(window.innerWidth<768);
  React.useEffect(()=>{const h=()=>setM(window.innerWidth<768);window.addEventListener('resize',h);return()=>window.removeEventListener('resize',h);},[]);
  return m;
}

const KrediYuklePage:React.FC<{config?:any}>=()=>{
  const { lang } = useLang();
  const isMobile=useIsMobile();
  const [balance,setBalance]=useState<number|null>(null);
  const [history,setHistory]=useState<any[]>([]);
  const [checkoutLoading,setCheckoutLoading]=useState('');
  const [toast,setToast]=useState('');
  const [agreed,setAgreed]=useState(false);

  const token=()=>localStorage.getItem('poyais_token')||localStorage.getItem('token')||'';
  const headers={'Content-Type':'application/json','Authorization':'Bearer '+token()};

  useEffect(()=>{
    fetch('/api/v1/credits/balance',{headers}).then(r=>r.json()).then(d=>setBalance(d.balance)).catch(()=>{});
    fetch('/api/v1/credits/history',{headers}).then(r=>r.json()).then(d=>setHistory(d.transactions||[])).catch(()=>{});
  },[]);

  useEffect(()=>{
    const params=new URLSearchParams(window.location.search);
    if(params.get('credit_success')==='1'){
      setToast('✓ Ödeme başarılı! Krediniz yüklendi.');
      setTimeout(()=>{
        fetch('/api/v1/credits/balance',{headers}).then(r=>r.json()).then(d=>setBalance(d.balance));
        fetch('/api/v1/credits/history',{headers}).then(r=>r.json()).then(d=>setHistory(d.transactions||[]));
      },2000);
      window.history.replaceState({},'',window.location.pathname);
    }
    if(params.get('credit_cancel')==='1'){
      setToast('Ödeme iptal edildi.');
      window.history.replaceState({},'',window.location.pathname);
    }
  },[]);

  const handleBuy=async(pkgId:string)=>{
    if(!agreed){ setToast('Lütfen önce Mesafeli Satış Sözleşmesini onaylayın.'); return; }
    setCheckoutLoading(pkgId);
    try{
      const res=await fetch('/api/v1/credits/checkout',{method:'POST',headers,body:JSON.stringify({package_id:pkgId,agreement_accepted:true,agreement_version:'v1.0',locale:lang})});
      const data=await res.json();
      if(data.checkout_url) window.location.href=data.checkout_url;
      else setToast('Checkout oluşturulamadı.');
    }catch{ setToast('Bir hata oluştu.'); }
    setCheckoutLoading('');
  };

  return(
    <div style={{maxWidth:860,fontFamily:'Manrope, sans-serif',padding: isMobile?'0 0 32px':'0 0 40px'}}>
      {toast&&(
        <div style={{position:'fixed',top:isMobile?70:80,right:isMobile?12:24,left:isMobile?12:'auto',background:toast.includes('✓')?alpha(T.green,95):alpha(T.red,95),color:'#fff',padding:'12px 20px',borderRadius:10,fontSize:13,fontWeight:600,zIndex:9999,boxShadow:'0 4px 20px rgba(0,0,0,.2)',textAlign:'center' as const}}>
          {toast}
        </div>
      )}

      {/* Mevcut bakiye */}
      <div style={{background:`linear-gradient(135deg,${alpha(T.accent,15)},${alpha(T.accent,7)})`,borderRadius:16,padding:isMobile?'20px 20px':'28px 32px',marginBottom:24,display:'flex',alignItems:isMobile?'flex-start':'center',justifyContent:'space-between',flexDirection:isMobile?'column' as const:'row' as const,gap:16}}>
        <div>
          <div style={{fontSize:11,color:T.amberDeepText,letterSpacing:'0.1em',marginBottom:6}}>MEVCUT KREDİ</div>
          <div style={{fontSize:isMobile?40:48,fontWeight:900,color:T.amberDeepText,letterSpacing:'-0.02em',lineHeight:1}}>
            {balance===null?'—':balance.toLocaleString('tr-TR')}
          </div>
          <div style={{fontSize:12,color:T.amberDeepText,marginTop:6}}>kredi</div>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:isMobile?6:8,width:isMobile?'100%':'auto'}}>
          {TOOL_COSTS.map(t=>(
            <div key={t.tool} style={{display:'flex',alignItems:'center',gap:6,fontSize:12,color:MT,background:alpha(T.accent,10),borderRadius:8,padding:'6px 10px'}}>
              <span style={{fontSize:14}}>{t.icon}</span>
              <span>{t.tool}</span>
              <span style={{color:GOLD,fontWeight:700,marginLeft:'auto'}}>{t.cost}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Sözleşme onayı */}
      <div style={{display:'flex',alignItems:'flex-start',gap:10,padding:'14px 16px',background:S2,borderRadius:10,marginBottom:20,border:`1px solid ${GOLD_BRD}`}}>
        <input type="checkbox" checked={agreed} onChange={e=>setAgreed(e.target.checked)} id="agreement-checkbox"
          style={{marginTop:2,width:16,height:16,accentColor:GOLD,cursor:'pointer',flexShrink:0}}/>
        <label htmlFor="agreement-checkbox" style={{fontSize:12,color:MT,lineHeight:1.6,cursor:'pointer'}}>
          <a href="https://poyaisone.com/sozlesmeler/mesafeli-satis-sozlesmesi" target="_blank" rel="noopener noreferrer" style={{color:GOLD,fontWeight:600,textDecoration:'none'}}>Mesafeli Satış Sözleşmesi</a>'ni okudum, kabul ediyorum.
        </label>
      </div>

      {/* Paketler */}
      <div style={{fontSize:11,color:MT,letterSpacing:'0.08em',marginBottom:14}}>KREDİ PAKETLERİ</div>
      <div style={{display:'grid',gridTemplateColumns:isMobile?'1fr':'repeat(3,1fr)',gap:isMobile?12:16,marginBottom:32}}>
        {PACKAGES.map(pkg=>(
          <div key={pkg.id} style={{
            background:pkg.popular?'linear-gradient(135deg,#2d1f00,#1a1000)':BG,
            border:`2px solid ${pkg.popular?GOLD:GOLD_BRD}`,
            borderRadius:14,
            padding:isMobile?'20px 16px':'24px 20px',
            position:'relative' as const,
            display:isMobile?'flex':'block',
            alignItems:isMobile?'center':'flex-start',
            gap:isMobile?16:0,
          }}>
            {pkg.popular&&<div style={{position:'absolute' as const,top:-11,left:'50%',transform:'translateX(-50%)',background:GOLD,color:T.accentInk,fontSize:10,fontWeight:800,padding:'3px 12px',borderRadius:20,letterSpacing:'0.06em',whiteSpace:'nowrap' as const}}>POPÜLER</div>}
            
            {/* Mobilde sol bilgi, sağ buton layout */}
            <div style={{flex:isMobile?1:undefined}}>
              <div style={{fontSize:13,fontWeight:700,color:pkg.popular?'rgba(255,255,255,.9)':TX,marginBottom:2}}>{pkg.name}</div>
              <div style={{fontSize:11,color:pkg.popular?'rgba(255,255,255,.4)':MT,marginBottom:isMobile?4:12}}>{pkg.desc}</div>
              {!isMobile&&<>
                <div style={{fontSize:36,fontWeight:900,color:pkg.popular?GOLD:TX,letterSpacing:'-0.02em',lineHeight:1,marginBottom:2}}>{pkg.credits.toLocaleString('tr-TR')}</div>
                <div style={{fontSize:11,color:pkg.popular?'rgba(255,255,255,.4)':MT,marginBottom:16}}>kredi</div>
                <div style={{fontSize:22,fontWeight:800,color:pkg.popular?'#fff':TX,marginBottom:16}}>₺{pkg.price.toLocaleString('tr-TR')}</div>
              </>}
              {isMobile&&(
                <div style={{display:'flex',alignItems:'baseline',gap:8}}>
                  <span style={{fontSize:22,fontWeight:900,color:pkg.popular?GOLD:TX}}>{pkg.credits.toLocaleString('tr-TR')}</span>
                  <span style={{fontSize:11,color:pkg.popular?'rgba(255,255,255,.4)':MT}}>kredi</span>
                  <span style={{fontSize:16,fontWeight:800,color:pkg.popular?'#fff':TX,marginLeft:8}}>₺{pkg.price.toLocaleString('tr-TR')}</span>
                </div>
              )}
            </div>
            <button onClick={()=>handleBuy(pkg.id)} disabled={checkoutLoading===pkg.id}
              style={{
                width:isMobile?'auto':'100%',
                flexShrink:isMobile?0:undefined,
                padding:isMobile?'10px 18px':'11px',
                borderRadius:8,border:`1px solid ${GOLD}`,
                background:pkg.popular?GOLD:alpha(T.accent,12),
                color:pkg.popular?T.accentInk:GOLD,
                fontSize:12,fontWeight:700,
                cursor:checkoutLoading===pkg.id?'wait':'pointer',
                fontFamily:'Manrope, sans-serif',
                transition:'all .2s',
                marginTop:isMobile?0:0,
                whiteSpace:'nowrap' as const,
                opacity:agreed?1:0.45,
              }}>
              {checkoutLoading===pkg.id?'…':'Satın Al'}
            </button>
          </div>
        ))}
      </div>

      {/* İşlem geçmişi */}
      {history.length>0&&(
        <>
          <div style={{fontSize:11,color:MT,letterSpacing:'0.08em',marginBottom:12}}>İŞLEM GEÇMİŞİ</div>
          <div style={{background:BG,border:`1px solid ${GOLD_BRD}`,borderRadius:12,overflow:'hidden'}}>
            {history.slice(0,20).map((tx:any,i:number)=>(
              <div key={tx.id} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:isMobile?'10px 14px':'12px 16px',borderBottom:i<Math.min(history.length,20)-1?`1px solid ${alpha(T.accent,8)}`:'none',gap:8}}>
                <div style={{minWidth:0,flex:1}}>
                  <div style={{fontSize:12,fontWeight:600,color:TX,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' as const}}>{tx.description||'İşlem'}</div>
                  <div style={{fontSize:10,color:MT,marginTop:2}}>{new Date(tx.created_at).toLocaleString('tr-TR')}</div>
                </div>
                <div style={{fontSize:14,fontWeight:800,color:tx.amount>0?GREEN:RED,flexShrink:0}}>{tx.amount>0?'+':''}{tx.amount}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default KrediYuklePage;
